import React, { PureComponent } from 'react';
import PT from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import { Image, Transition } from 'semantic-ui-react';
import YearDropdown from '../FilterComponents/YearDropdown';
import PrimaryDrowdown from '../FilterComponents/PrimaryDropdown';
import FiltersHeaderToggle from '../FilterComponents/FiltersHeaderToggle';
import { DropdownOptionsType } from '../../../lib/proptypes/semantic';
import Link from '../../../lib/components/link';
import classes from './filtersHeader.css';
import popupIcon from '../../../assets/images/icon-popup.svg';
import { selectBrowserMediaType } from '../../../store/reducers/browser';
import { selectYearsForDropdown } from '../../../store/reducers/season';
import { selectFormulasForDropdown, selectFormulas } from '../../../store/reducers/formula';
import { FormulaType } from '../../../lib/proptypes/formula';
import { CUSTOM_LEAGUE_EDIT_VIEW, CUSTOM_LEAGUE_VIEW, LEAGUE_DETAILS_VIEW } from '../../views/Custom/module/custom';
import api from '../../../lib/api';
import { map } from 'lodash';

const mapStateToProps = (state, ownProps) => ({
  years: selectYearsForDropdown(state, ownProps.seasonType, ownProps.statType),
  mediaType: selectBrowserMediaType(state),
  profiles: selectFormulasForDropdown(state),
  loggedIn: state.auth.loggedIn,
  formulas: selectFormulas(state),
});
const actions = {};
export class FiltersHeader extends PureComponent {
  static propTypes = {
    /* eslint-disable react/no-unused-prop-types */
    mediaType: PT.string,
    seasonType: PT.oneOf(['seasons', 'preseasons']).isRequired,
    statType: PT.oneOf(['stats', 'projections', 'predictions']).isRequired,
    /* eslint-enable */
    children: PT.oneOfType([
      PT.arrayOf(PT.node),
      PT.node,
    ]).isRequired,
    title: PT.string,
    selectedProfile: PT.number,
    selectedYear: PT.number,
    onChangeProfile: PT.func.isRequired,
    onChangeYear: PT.func,
    profiles: DropdownOptionsType,
    years: PT.arrayOf(PT.shape({
      key: PT.number,
      value: PT.number,
      text: PT.string,
    })),
    stacked: PT.bool,
    showPageHeading: PT.bool,
    showDate: PT.bool,
    showYear: PT.bool,
    showAlternateSubtitle: PT.bool,
    alternateSubtitle: PT.string,
    offFilters: PT.bool,
    formulas: PT.arrayOf(FormulaType),
  }

  static defaultProps = {
    profiles: [
      { key: 0, value: 0, text: 'Loading Options...' },
    ],
    years: [],
    stacked: false,
    showPageHeading: true,
    showDate: true,
    showYear: true,
    title: '',
    selectedYear: null,
    onChangeYear: null,
    showAlternateSubtitle: false,
    alternateSubtitle: '',
    offFilters: true,
    loggedIn: false,
    printLink: null,
    downloadLink: null,
    formulas: [],
  }

  state = {
    showFilters: true,
    didFirst: false,
    prevLogin: false,
    stateProfiles: [],
  }

  handleToggleShowFilters = () => {
    this.setState({ showFilters: !!!this.state.showFilters });
  }

  componentDidMount() {
    this.setState({ didFirst: true });
  }

  extractProfile = (inp) => {
    return { key: inp.id, value: inp.id, text: inp.name };
  }
  getSelectedProfile=(choices,active, mediaType)=>{
    let profileName;
    if(mediaType==='desktop')
      return ""
    try {
      const item=active===undefined?1:active
      const profileSelected = choices.find(c=>c.key===active)
      profileName=profileSelected.text.length < 43?profileName = "":profileSelected.text
    }catch (e) {
      profileName=''
    }
    return profileName
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.didFirst && this.state.prevLogin !== prevProps.loggedIn) {
      this.setState({ prevLogin: prevProps.loggedIn });
      const { formula: { getAll } } = api({});
      getAll().then(ret => {
        const profilesSorted = Object.values(ret.formulas).sort((a, b) => a.user_id - b.user_id);
        const profiles = map(profilesSorted, this.extractProfile);
        this.setState({ stateProfiles: profiles });
      });
    }
  }

  render = () => {
    const {
      profiles,
      selectedProfile,
      selectedYear,
      years,
      title,
      description,
      children,
      stacked,
      showPageHeading,
      showDate,
      showYear,
      mediaType,
      showAlternateSubtitle,
      alternateSubtitle,
      offFilters,
      loggedIn,
      printLink,
      downloadLink,
      formulas,
    } = this.props;
    const { showFilters, prevLogin, stateProfiles } = this.state;
    const filterYearProps = { selectedYear, years, onChangeYear: this.props.onChangeYear };

    /*for testing*/
    var item = {
      isExternal:true,
      key:"CONTACT_US",
      restricted:true,
      url:'http://thehuddle.com/myHuddle/',
    }

    // const preExistingLeagues = [1, 2, 3, 4, 5, 6, 7, 11, 12, 4436, 96662, 96672];
    const preExistingLeagues = formulas.reduce((acc, current) => {
      if (current.user_id === 0) {
        acc.push(current.id);
      }
      return acc;
    }, []);

    return (
      <div>
        { showPageHeading && (
          <div className={classes.pageHeading}>
            <div>
              { showYear && <YearDropdown {...filterYearProps} /> }
              { mediaType !== 'desktop' && offFilters && (
                <FiltersHeaderToggle
                  label={'Filters'}
                  showFilters={showFilters}
                  className={classes.filtersHeaderToggle}
                  onClick={(event) => this.handleToggleShowFilters()}
                />)
              }
            </div>
            <h1 className={classes.heading}>{title}</h1>
            {description && <p className={classes.description}>{description}</p>}
            <div className={classes.generatedOn}> {showAlternateSubtitle ? alternateSubtitle : ''} </div>
            {printLink && <a href={printLink} className={classes.printLink}>Printable Version</a>}
            {downloadLink && <span>&nbsp; | &nbsp;</span>}
            {downloadLink && <a href={downloadLink} className={classes.printLink}>Downloadable Version</a>}
          </div>
        )}
        {/* <Transition.Group animation="fade down" duration={{ hide: 150, show: 300 }}> */}
          { showFilters && offFilters && (
            <div className={classes.filterSection}>
              <div className={classes.filterByWrapper}>
                <div className="filterBy">FILTER BY:</div>
                <div className={stacked ? classes.controlsWrapperStacked : classes.controlsWrapper}>
                  {children}
                </div>
              </div>
              <div className={classes.scoringWrapper}>
                <h3 className={classes.subHeader}>
                  <span className={classes.bold}>myHUDDLE</span> Scoring
                </h3>
                <PrimaryDrowdown
                  choices={stateProfiles.length > 1 ? stateProfiles : profiles}
                  activeItem={selectedProfile}
                  onChange={this.props.onChangeProfile}
                  tooltip={true}
                  mediaType={mediaType}
                  toolTipText={this.getSelectedProfile(stateProfiles.length > 1 ? stateProfiles : profiles,selectedProfile,mediaType)}
                  label={'League Scoring Profile:'}
                />
                <div className={classes.scoringLinks}>
                  { preExistingLeagues.includes(selectedProfile)
                    ?
                    <Link target="_blank" to={{ type: LEAGUE_DETAILS_VIEW, payload: { id: selectedProfile } }}>
                      <Image inline src={popupIcon} /> View Scoring Details
                    </Link>
                    :
                    <Link target="_blank" to={{ type: CUSTOM_LEAGUE_EDIT_VIEW, payload: { id: selectedProfile } }}>
                      <Image inline src={popupIcon} /> View Scoring Details
                    </Link>
                  }
                  <Link to={{ type: CUSTOM_LEAGUE_VIEW }} label="Manage Profiles" />
                </div>
              </div>
            </div>
          )}
        {/* </Transition.Group> */}
      </div>
    );
  }
}
export default connect(mapStateToProps, actions)(FiltersHeader);



// WEBPACK FOOTER //
// ./src/app/components/FiltersHeader/FiltersHeader.js